function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_12",
  "data-name": "Group 12",
  transform: "translate(-252 -1235.045)"
}, React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M-620.812,704.99h-4.176a2.025,2.025,0,0,0-1.5.586,2.031,2.031,0,0,0-.586,1.5v20.855a10.057,10.057,0,0,1-3.063,7.368,10.045,10.045,0,0,1-7.367,3.062h-54.23a10.036,10.036,0,0,1-7.364-3.062,10.04,10.04,0,0,1-3.062-7.368V673.706a10.045,10.045,0,0,1,3.062-7.368,10.048,10.048,0,0,1,7.364-3.063h45.886a2.028,2.028,0,0,0,1.5-.586,2.028,2.028,0,0,0,.586-1.5v-4.172a2.028,2.028,0,0,0-.586-1.5,2.032,2.032,0,0,0-1.5-.586H-691.73a18.092,18.092,0,0,0-13.262,5.5,18.09,18.09,0,0,0-5.508,13.267v54.229a18.084,18.084,0,0,0,5.508,13.263,18.084,18.084,0,0,0,13.262,5.508h54.23a18.086,18.086,0,0,0,13.266-5.508,18.083,18.083,0,0,0,5.507-13.263V707.076a2.021,2.021,0,0,0-.589-1.5,2.028,2.028,0,0,0-1.5-.586Zm0,0",
  transform: "translate(962.5 580.11)"
}), React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M-684.7,725.849a4.014,4.014,0,0,0,2.933,1.24H-648.4a4,4,0,0,0,2.934-1.24,3.994,3.994,0,0,0,1.238-2.932,4,4,0,0,0-1.238-2.934l-11.469-11.469,42.5-42.5a2.055,2.055,0,0,0,.652-1.495,2.062,2.062,0,0,0-.652-1.5l-7.433-7.429a2.059,2.059,0,0,0-1.5-.654,2.061,2.061,0,0,0-1.5.654l-42.5,42.5-11.472-11.473a4.018,4.018,0,0,0-2.934-1.239,4.021,4.021,0,0,0-2.933,1.239,4.011,4.011,0,0,0-1.239,2.934v33.371a4,4,0,0,0,1.239,2.932Zm0,0",
  transform: "translate(962.5 580.11)"
}));

var SvgSignup = function SvgSignup(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 96.718,
    height: 91.771,
    viewBox: "0 0 96.718 91.771",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSignup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/signup.3b6fb03f.svg";
export { ForwardRef as ReactComponent };